import React from 'react';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Button from '../components/elements/Button';
import { Link } from 'react-router-dom';

const TechDivision = () => {
  const techHeader = {
    title: 'Technology & Digital Solutions Group',
    paragraph: 'Delivering end-to-end digital infrastructure, enterprise software asset management, multi-channel e-commerce systems, hands-on hardware deployments, and B2B lead growth engines.',
  };

  const techPillars = [
    {
      num: '05',
      title: 'Multi-Channel E-Commerce & Marketplace Operations',
      bullets: [
        'Global Digital Portals: Scalable online storefronts designed for international product discovery, wholesale ordering, and customer acquisition.',
        'Multi-Currency Merchant Ecosystems: Fully integrated digital transaction environments supporting secure, multi-currency processing.',
        'Interactive Marketplace Architecture: Designing, hosting, and operating scalable multi-vendor aggregators and commercial platforms.'
      ]
    },
    {
      num: '06',
      title: 'Enterprise Software Distribution & Asset Management',
      bullets: [
        'SaaS & Enterprise Reselling: Authorized distribution of software packages, productivity suites, enterprise OS, and business applications.',
        'Cloud & Mobile App Provisioning: Sourcing, licensing, and deployment of secure applications for healthcare, finance, and logistics.',
        'Software Asset Management: Helping corporate entities evaluate, acquire, and maintain optimized software licensing structures.'
      ]
    },
    {
      num: '07',
      title: 'On-Site IT Infrastructure & Hardware Deployment',
      bullets: [
        'Server & Network Deployment: Assembly and configuration of physical server racks, enterprise computer networks, and multi-office workstations.',
        'Infrastructure Cabling & Setup: Hardware integration, physical wiring, router setups, and system testing for corporate real estate.',
        'Rapid System Maintenance: Supporting enterprise infrastructure with on-site hardware troubleshooting, recovery, and performance upgrades.'
      ]
    },
    {
      num: '08',
      title: 'Strategic IT Consultancy & System Architecture',
      bullets: [
        'Enterprise Tech Audits: In-depth workflow evaluations to recommend, architect, and integrate custom software ecosystems.',
        'Digital Transformation Frameworks: Guiding corporate clients through seamless migrations from legacy setups to cloud environments.',
        'Feasibility & Performance Analysis: Technical feasibility studies designed to maximize return on technology investments.'
      ]
    },
    {
      num: '09',
      title: 'Digital Growth, Performance Marketing & B2B Lead Engine',
      bullets: [
        'Global Campaign Management: Multi-channel digital marketing execution across global advertising networks and business platforms.',
        'Qualified B2B Lead Blocks: Acquiring, verifying, and routing high-intent customer lead blocks for enterprise sales pipelines.',
        'Performance Marketing Engines: Conversion-focused digital campaigns designed to maximize international market penetration.'
      ]
    }
  ];

  return (
    <>
      <GenericSection topOuterDivider pb={0}>
        <SectionHeader data={techHeader} className="center-content" />
      </GenericSection>

      {/* 5 Tech Pillars Grid (3 on Top Row, 2 on Bottom Row) */}
      <section className="container mb-48">
        {/* Top Row: 3 Boxes Equally Spaced */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px', marginBottom: '24px', alignItems: 'stretch' }}>
          {techPillars.slice(0, 3).map((pillar, idx) => (
            <div key={idx} className="p-24" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
              <div>
                <div style={{ color: '#A88756', fontWeight: '500', fontSize: '0.85rem', marginBottom: '8px' }}>Tech Pillar {pillar.num}</div>
                <h4 className="mt-0 mb-16" style={{ color: '#A88756', fontSize: '1.2rem' }}>{pillar.title}</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {pillar.bullets.map((b, bIdx) => (
                    <li key={bIdx} className="mb-12 text-sm" style={{ color: '#CBD5E1', lineHeight: '1.6' }}>
                      • {b}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Row: 2 Boxes Equally Dividing 50%/50% */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px', alignItems: 'stretch' }}>
          {techPillars.slice(3, 5).map((pillar, idx) => (
            <div key={idx} className="p-24" style={{ backgroundColor: '#141C2E', borderRadius: '8px', border: '1px solid #1E293B', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
              <div>
                <div style={{ color: '#A88756', fontWeight: '500', fontSize: '0.85rem', marginBottom: '8px' }}>Tech Pillar {pillar.num}</div>
                <h4 className="mt-0 mb-16" style={{ color: '#A88756', fontSize: '1.2rem' }}>{pillar.title}</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {pillar.bullets.map((b, bIdx) => (
                    <li key={bIdx} className="mb-12 text-sm" style={{ color: '#CBD5E1', lineHeight: '1.6' }}>
                      • {b}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Consultancy & Project Inquiry Section */}
      <GenericSection topDivider>
        <div className="container" style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}>
          <h3 className="mt-0 mb-16" style={{ color: '#A88756' }}>Inquire About Technology & Digital Solutions</h3>
          <p className="text-sm text-color-high mb-32" style={{ color: '#CBD5E1', lineHeight: '1.6' }}>
            Whether you need enterprise hardware deployment, software asset optimization, custom marketplace architecture, or B2B lead engines, our team is ready to deliver.
          </p>
          <div>
            <Link to="/contact">
              <Button color="primary">Inquire For Tech Solutions →</Button>
            </Link>
          </div>
        </div>
      </GenericSection>
    </>
  );
};

export default TechDivision;
